import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "firewall_solid",
  "use": "firewall_solid-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"firewall_solid\"><path d=\"M20 3c-3.71 0-7.52-1.88-7.55-1.89L12 .88l-.45.22C11.52 1.12 7.72 3 4 3H3v7.03c0 5.29 2.94 10.05 7.68 12.42l1.32.66 1-.5V3.51c1.39.55 3.62 1.27 6 1.44v5.07c0 4.3-2.27 8.19-5.97 10.3.12.72.64 1.31 1.32 1.54C18.48 19.35 21 14.91 21 10.01V3h-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol